import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { Input, Row, Select, Table, Tag, Typography } from "antd";
import "./applicationList.scss";
import { applicationConfig, applicationList } from "../../../apis/admin";
import { replaceUrlByParams } from "../../../utils/api";
import { PAGE } from "../../../utils/constants";
import { AppContext } from "../../../App";
import BatchImportResult from "../../../components/batchImportResult/batchImportResult";

function ApplicationList(props) {
	const { pid } = useParams();
	let history = useHistory();
	const { sectionIdOption, applicationCount } = props;
	const { Text } = Typography;
	const { Search } = Input;
	const { Option } = Select;

	const [applicationListCol, setApplicationListCol] = useState([]);
	const [applicationListData, setApplicationListData] = useState([]);
	const [configSearchFilter, setConfigDynamicSearchFilter] = useState({
		search: "",
		filter: [],
	});

	const [searchFilter, setSearchFilter] = useState({
		search: "",
		filter: {},
	});

	const { setLoading } = useContext(AppContext);

	useEffect(() => {
		getApplicationConfig();
		getApplicationList();
	}, [searchFilter]);

	const getApplicationConfig = async () => {
		try {
			const res = await applicationConfig(pid);
			if (res.error) {
				throw new Error(`${res.error.msgCode} - ${res.error.message}`);
			} else {
				setApplicationListCol(
					res.columns.map((col) => {
						const tag =
							col.type === "paymentStatus"
								? {
										render: (status) => {
											return (
												<Tag
													color={
														status === "pending"
															? "red"
															: "green"
													}
													key={status}
												>
													{status === "pending"
														? "等待付款"
														: "已付款"}
												</Tag>
											);
										},
								  }
								: "";

						return {
							...tag,
							title: col.name,
							dataIndex: col.id,
							key: col.id,
						};
					})
				);

				setConfigDynamicSearchFilter({
					search: res.searchable.join(" / "),
					filter: res.filter,
				});
			}
		} catch (e) {
			console.log(e);
		}
	};

	const getApplicationList = async () => {
		setLoading(true);
		try {
			const res = await applicationList(
				pid,
				searchFilter.search,
				searchFilter.filter
			);
			if (res.error) {
				throw new Error(`${res.error.msgCode} - ${res.error.message}`);
			} else {
				setApplicationListData(
					res.map((data, i) => {
						return {
							...data.result,
							key: i,
						};
					})
				);
			}
		} catch (e) {
			console.log(e);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="application-list">
			<Row className="action-bar">
				<Row>
					<Search
						placeholder={configSearchFilter.search}
						onSearch={(e) =>
							setSearchFilter({ ...searchFilter, search: e })
						}
					/>

					{configSearchFilter.filter.map((filter, i) => {
						return (
							<Select
								key={i}
								placeholder={filter.name}
								id={filter.id}
								allowClear={true}
								onChange={(e) =>
									setSearchFilter({
										...searchFilter,
										filter: { [filter.id]: e },
									})
								}
							>
								{filter.choices.map((choice, j) => {
									return (
										<Option
											key={j}
											id={choice.id}
											value={choice.id}
										>
											{choice.name}
										</Option>
									);
								})}
							</Select>
						);
					})}
				</Row>

				<BatchImportResult
					pid={pid}
					sectionIdOption={sectionIdOption}
				/>
			</Row>
			<Text strong className="total-application">
				共有{(applicationListData || []).length}份申請
			</Text>
			<Table
				pagination={false}
				columns={applicationListCol}
				dataSource={applicationListData}
				onRow={(record, rowIndex) => {
					return {
						onClick: (event) => {
							history.push(
								`${replaceUrlByParams(
									PAGE.ADMIN_APPLICATION_DETAIL,
									{
										":pid": pid,
										":id": record.applicationNumber,
									}
								)}`
							);
						},
					};
				}}
			/>
		</div>
	);
}

export default ApplicationList;
